import { render, staticRenderFns } from "./reys.vue?vue&type=template&id=21957c04&scoped=true&"
import script from "./reys.vue?vue&type=script&lang=js&"
export * from "./reys.vue?vue&type=script&lang=js&"
import style0 from "./reys.vue?vue&type=style&index=0&id=21957c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21957c04",
  null
  
)

export default component.exports